import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";

export interface ProductPriceParameter {
    productId: string;
    unitOfMeasure: string;
    qtyOrdered: number;
    configuration?: string[];
}

type LoadStoolParameters = {
    onError?: (error: string) => void;
} & { items: ProductPriceParameter[] } & HasOnSuccess<ProductPriceDto[]>;

type HandlerType = ApiHandler<LoadStoolParameters, ProductPriceDto[]>;

export const PopulateApiParameter: HandlerType = props => {
    throwErrorIfTesting();

    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    let stoolItemsUpdated = false;

    if (!props.apiParameter.items || !props.apiParameter.items.length) {
        return false;
    }

    // We make the call to load real time pricing to get the items
    // that have the additionalResults.spoolSelected set to "1" or not empty and we save them in a new array
    // we then update the cartLines to include the spools property for the items that
    // have the additionalResults.spoolSelected set to "1" or not empty

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: props.apiParameter.items,
            onSuccess: realTimePricing => {
                const reorderItemsWithStool = realTimePricing.realTimePricingResults?.filter(
                    o => o.additionalResults?.spoolSelected === "1" || o.additionalResults?.spoolSelected,
                ) as ProductPriceDto[];

                stoolItemsUpdated = true;
                if (reorderItemsWithStool.length > 0) {
                    props.apiResult = reorderItemsWithStool;
                }
            },
            onError: () => {
                console.log("Error loading real time pricing");

                props.apiResult = [];
                stoolItemsUpdated = true;
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );

    await waitFor(() => stoolItemsUpdated);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const customLoadStoolItems = createHandlerChainRunner(chain, "CustomLoadStoolItems");
export default customLoadStoolItems;
